<template>
  <MarketReportCard
    :title="$t('market_insights.forward_outlook.title')"
    :description="$t('market_insights.forward_outlook.description')"
    icon="fa-solid fa-file-pdf"
    action-icon="fa-solid fa-external-link"
    :action-text="$t('common.open_pdf')"
    :href="pdfUrl"
    :badge="FORWARD_OUTLOOK_LAST_UPDATED"
  />
</template>

<script setup lang="ts">
import { useAccount } from "@/composables/account/useAccount";
import {
  FORWARD_OUTLOOK_LAST_UPDATED,
  FORWARD_OUTLOOK_URL,
  SHORT_FORWARD_OUTLOOK_URL,
} from "@/constants";
import { computed } from "vue";
import MarketReportCard from "./MarketReportCard.vue";

const { accountData } = useAccount();

const hasForwardSalesEnabled = computed(() => {
  return accountData.companies.some(
    (company) => company.forward_sales_enabled === true
  );
});

const pdfUrl = computed(() =>
  hasForwardSalesEnabled.value ? FORWARD_OUTLOOK_URL : SHORT_FORWARD_OUTLOOK_URL
);
</script>
